import script from "./PostMeta.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostMeta.vue?vue&type=script&setup=true&lang=ts"

import "./PostMeta.vue?vue&type=style&index=0&id=090e0768&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-090e0768"]])

export default __exports__